import { inject } from '@angular/core';
import { CanActivateFn, NavigationCancel, NavigationEnd, NavigationError, NavigationSkipped, Router } from '@angular/router';
import { filter, take } from 'rxjs';

import { APP_LOADING_CONTENT } from 'app/home/app-global-loader/service/app-loader-content';
import { AppLoaderService } from 'app/home/app-global-loader/service/app-loader.service';

/**
 * Turns the app loader on before the direct quote route activates, so the layout's first paint is already covered by
 * the loader and the header/footer never flash. Once the route activates, `DirectQuoteComponent` owns the loader and
 * releases it after routing to the draft's destination, or when it's destroyed.
 *
 * If this navigation doesn't complete (e.g. it's cancelled or the lazy component fails to load), no component exists
 * to turn the loader off, so the guard turns it off itself.
 */
export const showDirectQuoteLoader: CanActivateFn = () => {
  const appLoaderService = inject(AppLoaderService);

  appLoaderService.on(APP_LOADING_CONTENT.directQuote);

  inject(Router)
    .events.pipe(
      filter((event) => event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError || event instanceof NavigationSkipped),
      take(1),
    )
    .subscribe((event) => {
      if (!(event instanceof NavigationEnd)) {
        appLoaderService.off();
      }
    });

  return true;
};
